<script setup lang="ts">
defineEmits(['change']);

const props = defineProps<{
  rating: number;
  editable?: boolean;
  size?: string;
}>();

const editableRating = ref(props.rating || 0);
const roundedRating = computed(() => Number(props.rating.toFixed()));
</script>

<template>
  <div class="rating">
    <span
      v-for="n in 5"
      :key="n"
      class="rating__icon"
      @mouseover="editableRating = 6 - n"
      @mouseout="editableRating = rating"
      @click="$emit('change', editableRating)"
    >
      <SvgoStar
        filled
        :font-controlled="false"
        :class="[
          6 - (editable ? editableRating : roundedRating) <= n ? 'text-hell-black' : 'text-hell-black-20',
          `w-${size ?? '4'} h-${size ?? '4'}`,
        ]"
      />
    </span>
  </div>
</template>

<style scoped lang="scss">
.rating {
  display: flex;
  align-items: center;
  unicode-bidi: bidi-override;
  direction: rtl;

  &__icon {
    padding-right: 0.125rem;
    padding-left: 0.125rem;
  }
}
</style>
